<template>
 <div>
   <el-card class="invoice-approve">
     <el-form>
       <el-form-item label="状态:">
         <el-select v-model="approveForm.status" size="small" @change="statusChange">
           <el-option v-for="item in statusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
         </el-select>
       </el-form-item>
     </el-form>
     <el-table :data="invoiceData" >
       <template v-for="(item,index) in tableColumns">
         <el-table-column :prop="item.key" :label="item.label" :min-width="item.width" :key="index"></el-table-column>
       </template>
       <el-table-column v-if="approveForm.status===0" label="操作" :min-width="150" fixed="right">
         <template slot-scope="scope">
           <el-button size="small" type="success" @click="handleFn(scope.row,'pass')" >通过</el-button>
           <el-button size="small" type="danger" @click="handleFn(scope.row,'reject')" >驳回</el-button>
           <el-button size="small" type="primary" @click="toDetail(scope.row)" >详情</el-button>
         </template>
       </el-table-column>
     </el-table>
    <PageComponent ref="pageInfo"></PageComponent>
   </el-card>
  <el-dialog
    width="500px"
    :title="handleType==='pass'?'通过':'驳回'"
    :visible.sync="dialogVisible"
    @close="handleClose"
    :close-on-click-modal="false">
    <div>
      <el-form :model="approveOperateForm" ref="approveOperateForm" :rules="rules" label-width="100px" size="small">
        <template v-if="handleType === 'pass'">
          <p v-if="handleRowInfo.invoiceSendType===1">请确认已发送电子发票至<span style="color:#11A49F;"> {{handleRowInfo.email}} </span>邮箱。</p>
          <!-- 纸质发票需要填写物流信息 -->
          <template v-else>
            <el-form-item label="物流公司：" prop="logisticsCompany">
              <el-input v-model="approveOperateForm.logisticsCompany" size="small"></el-input>
            </el-form-item>
            <el-form-item label="物流单号：" prop="logisticsOrderNo">
              <el-input v-model="approveOperateForm.logisticsOrderNo" size="small"></el-input>
            </el-form-item>
          </template>
        </template>
        <el-form-item v-if="handleType === 'reject'" label="驳回理由" prop="approvalNote">
          <el-input v-model="approveOperateForm.approvalNote" size="small"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
 </div>
</template>
<script>
import PageComponent from "@/components/pageInfo/PageComponent";
import { formatDateTime } from "@/utils/util.js"
const columns = [
  {key: 'loginId', label: '申请用户', width: '160'},
  {key: 'company', label: '所属公司', width: '160'},
  {key: 'createDateSelf', label: '申请时间', width: '160'},
  {key: 'invoiceAmount', label: '发票总额', width: '100'},
  {key: 'note', label: '发票备注', width: '100'},
  {key: 'invoiceSendTypeSelf', label: '发票性质', width: '100'},
  {key: 'statusSelf', label: '发票状态', width: '100'},
]
export default {
  components: { PageComponent },
  data() {
    return {
      invoiceData: [],
      tableColumns: columns,
      statusList: [
        {value: 0,label: '开票中'},
        {value: 1,label: '已开票'},
        {value: 5,label: '撤销'},
        {value: 9,label: '驳回'},
      ],
      // 发票状态
      statusObj: {
        0: '开票中',
        1: '已开票',
        5: '撤销',
        9: '驳回'
      },
      approveForm: {
        status: 0
      },
      handleType: '',
      handleRowInfo: {},
      dialogVisible: false,
      approveOperateForm: {
        logisticsCompany: '',
        logisticsOrderNo: '',
        approvalNote: '', //驳回理由
      },
      rules: {
        logisticsCompany: [{required: true, message: '请输入物流公司', trigger: 'blur'}],
        logisticsOrderNo: [{required: true, message: '请输入物流单号', trigger: 'blur'}],
        approvalNote: [{required: true, message: '请输入驳回理由', trigger: 'blur'}]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.$refs.pageInfo.initPagenator(this.getList, 10);
    this.getList();
  },
  methods: {
    // 获取审批list
    getList() {
      let params = {
        status: this.approveForm.status, // 开票中
        page: this.$refs.pageInfo.currentPage,
        pageSize: 10,
      }
      this.getRequest('/dev/system/ofc/invoiceLog/search',params).then(res => {
        // console.log(res)
         if(res.status == 200) {
          if(res.data.code == 1000) {
            this.invoiceData = res.data.result.records.map(item => {
              return Object.assign(item,{
                createDateSelf: this.formatDateTime(item.createDate),
                invoiceTypeSelf: item.invoiceType === 0? '增值税普通发票':(item.invoiceType === 1?'增值税专用发票':''),
                invoiceSendTypeSelf: item.invoiceSendType === 0? '纸质':(item.invoiceSendType === 1?'电子':''),
                statusSelf: this.statusObj[item.status],
              })
            })
            this.$refs.pageInfo.outputPagenator(res.data.result.total);
          }
         }
      })
    },
    // 状态更改
    statusChange() {
      var queryStr = JSON.parse(JSON.stringify(this.$route.query));
      queryStr.page = 1;
      this.$router.push({query: queryStr});
      this.getList();
    },
    // 通过、驳回操作
    handleFn(row,type) {
      this.dialogVisible = true;
      this.handleType = type;
      this.handleRowInfo = row;
    },
    handleClose() {
      this.$refs.approveOperateForm.resetFields();
      this.$refs.approveOperateForm.clearValidate();
      this.handleType = '';
      this.handleRowInfo = {};
      this.dialogVisible = false;
    },
    submit() {
      this.$refs.approveOperateForm.validate(valid => {
        if(valid) {
          let params = Object.assign({},this.handleRowInfo),url='/ofc/invoiceLog/admin/update';
          if(this.handleType === 'pass') {
            params.logisticsCompany = this.approveOperateForm.logisticsCompany;
            params.logisticsOrderNo = this.approveOperateForm.logisticsOrderNo;
            params.status = 1;//通过
          } else if(this.handleType === 'reject') {
            params.approvalNote = this.approveOperateForm.approvalNote;
            params.status = 9;//驳回
          }
          this.postRequestJson(url, params).then(res => {
            if(res.status === 200) {
              if(res.data.code === 1000) {
                 this.$message.success('保存成功！');
                this.handleClose();
                this.getList();
              } else {
                this.$message.error(res.data.message);
              }
            }
          })
        }
      })
    },
    // 发票详情
    toDetail(row) {
      this.$router.push({
        path: '/invoice/detail',
        query: {
          invoiceLogId: row.id
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
 .invoice-approve {
   margin-top: 15px;
 }
</style>
